import { render, staticRenderFns } from "./ccm-my-point-list.vue?vue&type=template&id=95eae25c&"
import script from "./ccm-my-point-list.vue?vue&type=script&lang=js&"
export * from "./ccm-my-point-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports